<script>
export default {
  name: "discoverMore"
};
</script>

<template>
  <el-row style="padding: 40px 0 40px 0; background-color: #101010">
    <el-col :span="24">
      <span class="u-connect-bold">U-Connect&nbsp;</span>
      <span class="u-connect-regular"
        >- Connect your clients to a property today</span
      >
      <el-col
        :span="24"
        style="display: flex; justify-content: center; padding: 0 16px 16px 16px"
      >
        <el-button class="u-connect-btn" type="primary"
          >Discover more</el-button
        >
      </el-col>
    </el-col>
  </el-row>
</template>

<style scoped>
.u-connect-bold {
  color: #ffffff;
  font-feature-settings: "clig" off, "liga" off;
  font: 600 34px Metropolis, sans-serif;
  display: flex;
  justify-content: flex-start;
  padding: 0 16px;
}

.u-connect-regular {
  color: #ffffff;
  font-feature-settings: "clig" off, "liga" off;
  font: 400 34px Metropolis, sans-serif;
  display: flex;
  justify-content: flex-start;
  padding: 0 16px;
}

.u-connect-btn {
  color: #ffbe00;
  text-align: center;
  border: 3px solid #ffbe00;
  background-color: #2d2d2d;
  width: 100%;
  margin-top: 24px;
  font: 600 20px Metropolis, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/package/discoverMore.vue